export var Access;
(function (Access) {
    Access["Admin"] = "Admin";
})(Access || (Access = {}));
